$(function () {
    $('.notification-link').click(function (e) {
        //e.preventDefault();

        var message = $(this);

        message.addClass('d-none hidden');

        var messageBox = message.closest('.notification-box');

        var menu = message.closest('.dropdown-menu');

        (!messageBox.hasClass('message-unread'))
        {
            stopMenuFromClosing(menu, e);
        }

        var container = messageBox.closest('.notification-container');
        var url = container.data('url');

        $.post(url, { id: message.data('message-id') }, function (response) {
            if (response.httpCode === 200) {
                messageBox.removeClass('message-unread bg-light').addClass('message-read bg-white');

                var notificationCount = container.find('.notification-count:first');

                var count = Number(notificationCount.text());

                if (count <= 1) {
                    notificationCount.addClass('d-none hidden');
                }

                notificationCount.text(count - 1);
            } else { message.removeClass('d-none hidden'); }
        });

        stopMenuFromClosing(menu, e);
    });

    function stopMenuFromClosing(menu, e) {

        if (!menu.length || !menu.hasClass('keep-open-on-click')) {
            return;
        }

        e.stopPropagation();
    }
});
